export default "__VITE_ASSET__CSDImoqk__"